<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
<!--            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>-->
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <el-table
            :data="tableData" border
            style="width: 100%" size="small">
            <el-table-column type="expand">
              <template slot-scope="props">
                <div style="margin: 10px">
                <el-divider content-position="left" >床位信息  <el-button v-if="!props.row.bedinfo" type="primary" icon="el-icon-plus" size="mini" @click="bededitModal(props.row, '', 'post', '新增床位信息')"></el-button></el-divider>
                <el-table
                  size="small"
                  :data="props.row.bedinfo"
                  style="width: 100%;"
                  max-height="300"
                  border
                  :cell-style="{padding:'0px'}"
                >
                  <el-table-column
                    prop="bed"
                    label="床位"
                    align="center"
                    fixed>
                  </el-table-column>
                  <el-table-column
                    prop="type_CN"
                    label="类型"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="state_CN"
                    label="状态"
                    align="center"
                    fixed>
                  </el-table-column>
                  <el-table-column
                    prop="pid"
                    label="入住人员"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="remark"
                    label="备注"
                    width="200"
                    align="center">
                  </el-table-column>
                  <el-table-column align="center" width="180">
                    <template slot="header" slot-scope="scope">
                      操作
                    </template>
                    <template slot-scope="scope">
                       <div style="margin: 5px;">
                      <el-button-group>
                        <el-button type="primary" icon="el-icon-plus" size="mini" @click="bededitModal(props.row, '', 'post', '新增床位信息')"></el-button>
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="bededitModal(props.row, scope.row, 'post', '床位信息')"></el-button>
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="delDatabed(scope, props)"></el-button>
                      </el-button-group>
                       </div>
                    </template>

                  </el-table-column>

                </el-table>
                  </div>
              </template>
            </el-table-column>
            <el-table-column
              label="房间" align="center"
              prop="rom" sortable tooltip>
            </el-table-column>
            <el-table-column
              label="床位数" align="center"
              prop="beds" sortable tooltip>
            </el-table-column>
            <el-table-column
              label="已入住人数" align="center"
              prop="perins" sortable tooltip>
            </el-table-column>
            <el-table-column
              label="类型" align="center"
              prop="type_CN" sortable tooltip>
            </el-table-column>
             <el-table-column
              label="状态" align="center"
              prop="state_CN" sortable tooltip>
            </el-table-column>
            <el-table-column
              label="备注" align="center"
              prop="remark" sortable tooltip>
            </el-table-column>

            <el-table-column align="center" width="200">
              <template slot="header" slot-scope="scope">
                操作
              </template>
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="editModal(scope.row, 'post', '宿舍信息')">编辑</el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click="delData(scope)">删除</el-button>
              </template>

            </el-table-column>

          </el-table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="房间"
                prop="rom"
              >
                <Input
                  v-model="formValidate.rom"
                  placeholder="请输入房间"
                ></Input>
              </FormItem>
              <FormItem
                label="床位数"
                prop="beds"
              >
                <Input
                  v-model="formValidate.beds"
                  placeholder="请输入床位数"
                ></Input>
              </FormItem>
               <FormItem
                label="类型"
                prop="type"
              >
                <el-select
                  v-model="formValidate.type"
                  filterable
                  default-first-option
                  placeholder="请选择类型">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="状态"
                prop="state"
              >
                <el-select
                  v-model="formValidate.state"
                  filterable
                  default-first-option
                  placeholder="请选择状态">
                  <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="备注"
                prop="remark"
              >
                <Input
                  v-model="formValidate.remark"
                  placeholder="请输入备注"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
          <Modal v-model="modalMapbed.modalVisible" :title="modalMapbed.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidatebed" :model="formValidatebed" :rules="ruleValidatebed" :label-width="100">
            <el-divider>
                <div>
    <span>{{formValidatebed.roominfo.remark}}</span>
    <el-divider direction="vertical" v-if="formValidatebed.roominfo.remark"></el-divider>
    <span>{{formValidatebed.roominfo.rom}}</span>
    <el-divider direction="vertical"></el-divider>
    <span>{{formValidatebed.roominfo.type_CN}}</span>
  </div>
            </el-divider>
              <FormItem
                label="床位"
                prop="bed"
              >
                <Input
                  v-model="formValidatebed.bed"
                  placeholder="请输入房间"
                ></Input>
              </FormItem>
               <FormItem
                label="类型"
                prop="type"
              >
                <el-select
                  v-model="formValidatebed.type"
                  filterable
                  default-first-option
                  placeholder="请选择类型">
                  <el-option
                    v-for="item in bedtypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="状态"
                prop="state"
              >
                <el-select
                  v-model="formValidatebed.state"
                  filterable
                  default-first-option
                  placeholder="请选择状态">
                  <el-option
                    v-for="item in bedstateList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
               <FormItem
                label="入住人员"
                prop="pid"
              ><Input v-if="formValidatebed.type!=1"
                  v-model="formValidatebed.pid"
                  placeholder="请输入入住人员，多人可用，号分割"
                ></Input>
                 <Row v-if="formValidatebed.type==1"><i-col>上<Input style="width: 97%"
                  v-model="formValidatebed.perup"
                  placeholder="请输入入住人员，多人可用，号分割"
                ></Input></i-col>
                <i-col >下<Input style="width: 97%"
                  v-model="formValidatebed.perdown"
                  placeholder="请输入入住人员，多人可用，号分割"
                ></Input> </i-col></Row>

              </FormItem>
              <FormItem
                label="备注"
                prop="remark"
              >
                <Input
                  v-model="formValidatebed.remark"
                  placeholder="请输入备注"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidatebed')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidatebed')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getRoominfolist, operationBedinfo,
  operationRoominfo,
} from '@/api/roominfo/roominfo.js'
import {getsysparameterList} from "@/api/system/sys_parameter";

let moment = require("moment");
export default {
  data() {
    return {
      spinShow: false,
      fullscreenLoading: false,
      stateList: [],
      typeList: [],
      bedstateList: [],
      bedtypeList: [],
      formValidate: {},
      formValidatebed: {
        roominfo:{
          remark:"",
          rom:"",
          type_CN:""
        }
      },
      searchVal: "",
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: "新建"
      },
      modalMapbed: {
        modalVisible: false,
        modalTitle: "新建"
      },
      tableSelectIdList: [],
      editModalbed: "",
      editModalData: "",
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        rom: [
          {
            required: true,
            message: "房间不能为空",
            trigger: "blur"
          }
        ]
      },
            ruleValidatebed: {
        bed: [
          {
            required: true,
            message: "床位不能为空",
            trigger: "blur"
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: "房间",
          key: "rom",
          width: 120,
          align: "center",
          tooltip:"true",
          sortable: true        },
        {
          title: "床位数",
          key: "beds",
          width: 120,
          tooltip:"true",
          align: "center",
          sortable: true        },
        {
          title: "床位数",
          key: "beds",
          width: 120,
          tooltip:"true",
          align: "center",
          sortable: true        },
        {
          title: "已入住人数",
          key: "perin",
          width: 120,
          tooltip:"true",
          align: "center",
          sortable: true        }
,        {
          title: "状态",
          key: "state_CN",
          width: 120,
          align: "center",
          sortable: true        },
        {
          title: "类型",
          key: "type_CN",
          width: 120,
          align: "center",
          sortable: true        }
,        {
          title: "备注",
          key: "remark",
          width: 250,
          tooltip:"true",
          align: "center",
          sortable: true        }
,        {
          title: "操作",
          key: "handle",
          fixed: "right",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, "post", "修改");
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.delData(params);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
    };
  },
  methods: {
    getRoominfolist(key, value) {
      this.spinShow = true
      getRoominfolist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList() {
      getsysparameterList('roominfo', 'state').then(res => {
        if (res.data.code === 0) {
          this.stateList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('roominfo', 'type').then(res => {
        if (res.data.code === 0) {
          this.typeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
        getParameterbedList() {
      getsysparameterList('bedinfo', 'state').then(res => {
        if (res.data.code === 0) {
          this.bedstateList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('bedinfo', 'type').then(res => {
        if (res.data.code === 0) {
          this.bedtypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSelectChange(val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal() {
      this.dialog.show = false
    },
    bededitModal(parent, paramsRow, meth, mtitle) {
      console.log(parent)
      this.modalMapbed.modalVisible = true;
      this.modalMapbed.modalTitle = mtitle;
      this.editModalbed = meth;
      this.getParameterbedList();
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate() + " " + day2.getHours() + ":" + day2.getMinutes() + ":" + day2.getSeconds();
      if (paramsRow && paramsRow.id) {
        this.formValidatebed = {
          roominfo: parent,
          id: paramsRow.id,
          bed: paramsRow.bed,
          pid: paramsRow.pid,
          state: paramsRow.state,
          type: paramsRow.type,
          remark: paramsRow.remark,
          per: paramsRow.per,
          perup: paramsRow.perup,
          perdown: paramsRow.perdown,
        }
      } else {
        this.formValidatebed = {
          roominfo:parent,
          id: 0,
          bed: '',
          pid:'',
          state: 1,
          type: 1,
          remark: '',
          per: '',
          perup: '',
          perdown: '',
        }
      }
    },
    editModal(paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true;
      this.modalMap.modalTitle = mtitle;
      this.editModalData = meth;

      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate() + " " + day2.getHours() + ":" + day2.getMinutes() + ":" + day2.getSeconds();
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          rom: paramsRow.rom,
          beds: paramsRow.beds,
          state: paramsRow.state,
          type: paramsRow.type,
          remark: paramsRow.remark
        }
      } else {
        this.formValidate = {
          id: 0,
          rom: '',
          beds: 0,
          state: 1,
          type: 1,
          remark: '',
          per: ''
        }
      }
    },
    handleSubmit(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            if (value == 'formValidatebed') {
              operationBedinfo(this.formValidatebed, this.editModalbed).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  if (this.searchVal) {
                    this.getRoominfolist(this.searchVal)
                  } else {
                    this.getRoominfolist()
                  }
                  this.modalMapbed.modalVisible = false
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
            }else{
              operationRoominfo(this.formValidate, this.editModalData).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  if (this.searchVal) {
                    this.getRoominfolist(this.searchVal)
                  } else {
                    this.getRoominfolist()
                  }
                  this.modalMap.modalVisible = false
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
            }
          }, 1000)
        } else {
          this.$Message.error("缺少必要参数");
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    handlerDelete() {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationRoominfo({'id_list': this.tableSelectIdList}, 'delete').then(            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getRoominfolist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delDatabed(params, parent) {
      console.log(parent.$index)
      console.log(this.tableData[parent.$index])
      if (confirm(`是否确认删除该床位！`)) {
        operationBedinfo(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {

          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData[parent.$index].bedinfo.splice(params.$index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    delData(params) {
      console.log(params)
      if (confirm(`是否确认删除该房间信息，床位信息和入住信息会同步删除！`)) {
        operationRoominfo(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {

          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.$index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage(value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getRoominfolist(this.searchVal)
      } else {
        this.getRoominfolist()
      }
    },
    handlePageSize(value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getRoominfolist(this.searchVal)
      } else {
        this.getRoominfolist()
      }
    },
    searchinput() {
      if (this.searchVal) {
        this.getRoominfolist(this.searchVal)
      } else {
        this.getRoominfolist()
      }
    }
  },
  watch: {
    searchVal(val) {
      this.searchVal = val
    }
  },
  mounted() {
    this.getParameterList();
    this.getRoominfolist();
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
